import { MaggieHttp } from '../MaggieHttp';
import { ITemplatesResponse } from '../../data-models/template.data-model';
import { IField } from '../../data-models/field2.data-model';
import { ICustomFieldDataDataModel } from '../../data-models/custom-field-data.data-model';
import { CustomFieldsUploadStatusData } from '../../schemas/CustomFieldsUploadStatusData.schema';

export async function fetchCustomFieldTemplates() {
  const { data } = await MaggieHttp.maggie.get<ITemplatesResponse>('/customField/templates');
  return data;
}

export async function fetchCustomFields<T>() {
  const { data } = await MaggieHttp.maggie.get<IField<T>[]>('/customField');
  return data;
}

export async function deleteCustomField<T>(customField: IField<T>): Promise<IField<T>> {
  await MaggieHttp.maggie.delete<number>(`/customField/${customField.id}`);
  return customField;
}

export async function createCustomField<T>(payload: Partial<IField<T>>) {
  const { data } = await MaggieHttp.maggie.post<Partial<IField<T>>, IField<T>>('/customField', payload);
  return data;
}

export async function updateCustomField<T>(payload: Partial<IField<T>>): Promise<IField<T>> {
  const { data } = await MaggieHttp.maggie.put<Partial<IField<T>>, IField<T>>(
    `/customField/${payload.id}`,
    payload
  );
  return data;
}

export async function fetchOptionUsage(fieldId: number, values: string[]): Promise<Record<string, number>> {
  const { data } = await MaggieHttp.maggie.get<Record<string, number>>(
    `/customField/${fieldId}/optionUsage`,
    { params: { values } }
  );
  return data;
}

export async function getCustomFieldDataHistory({
  entityId,
  customFieldId,
}: {
  entityId: number;
  customFieldId: number;
}): Promise<ICustomFieldDataDataModel[]> {
  const { data } = await MaggieHttp.maggie.get<ICustomFieldDataDataModel[]>(`/customFieldData/history`, {
    params: {
      entityId,
      customFieldId,
    },
  });
  return data;
}

export interface IUpdateCustomFieldDataPayload extends Omit<
  ICustomFieldDataDataModel,
  'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy'
> {
  id: number;
}

export async function bulkUpdateCustomFieldData(payload: IUpdateCustomFieldDataPayload[]) {
  const { data } = await MaggieHttp.maggie.put<IUpdateCustomFieldDataPayload[], ICustomFieldDataDataModel[]>(
    '/customFieldData/bulk',
    payload
  );
  return data;
}

export interface IUpsertCustomFieldDataPayload {
  entityId: number;
  customFieldId: number;
  // null clears the value.
  value: string | number | boolean | string[] | null;
  // Time-series fields only; the API defaults to today.
  date?: string;
}

export async function upsertCustomFieldData(payload: IUpsertCustomFieldDataPayload) {
  const { data } = await MaggieHttp.maggie.put<IUpsertCustomFieldDataPayload, ICustomFieldDataDataModel>(
    '/customFieldData',
    payload
  );
  return data;
}

export async function deleteCustomFieldData(id: number) {
  const { data } = await MaggieHttp.maggie.delete<ICustomFieldDataDataModel>(`/customFieldData/${id}`);
  return data;
}

export async function getCustomFieldsUploadStatusData() {
  const { data } = await MaggieHttp.maggie.get<CustomFieldsUploadStatusData[]>('/customField/status');
  return data;
}
